<!--
 * @Description: 
 * @Date: 2024-01-10 11:34:16
-->
<template>
  <div class="block">
    <div class="bi-tmpl-detail">
      <div class="bi-tmpl-detail__left">
        <div class="bi-tmpl-detail__left__header">
          <div style="font-weight: 600">分析模块</div>
          <BaseSelect
            style="width: 200px"
            placeholder="请选择场景"
            :disabled="isCheck"
            :options="
              Object.values(SCENE_MAPPING).sort((a, b) => a.sort - b.sort)
            "
            :model-value="state.sceneType"
            @change="onChangeScene"
          />
        </div>
        <BaseScrollbar style="height: calc(100% - 66px)" always>
          <ul class="bi-tmpl-detail__left__box">
            <li
              v-for="([key, item], index) in state.menuValue"
              class="bi-tmpl-detail__left__item pointer"
              :key="key"
              :style="{
                cursor: !item.renderChild ? 'pointer' : '',
                paddingTop: index === 0 ? '24px' : '16px'
              }"
              @click.stop="onChangeMenu(key, item.defaultChildKey)"
            >
              <div
                :class="[
                  'bi-tmpl-detail__left__item__content',
                  menuClassNameActive(key),
                  'pointer'
                ]"
              >
                <div class="bi-tmpl-detail__left__item__content__headline">
                  <div
                    class="bi-tmpl-detail__left__text"
                    :class="{
                      'bi-tmpl-detail__left__text__tip': +key === 18
                    }"
                  >
                    <span style="margin-right: 9px; height: 20px">
                      <base-svg
                        :iconClass="item.iconName"
                        :className="menuIconClassNameActive(key)"
                      ></base-svg>
                    </span>
                    <span>
                      {{ item.title }}
                    </span>
                  </div>
                  <div class="bi-tmpl-detail__left__switch">
                    <BaseSwitch
                      v-if="showVisible(key)"
                      size="small"
                      :model-value="item.show"
                      :activeValue="true"
                      :activeText="item.show ? '展示' : '不展示'"
                      :inactiveValue="false"
                      :disabled="!preValueDone(key) || isCheck"
                      @click.stop
                      @change="
                        e =>
                          onChangeSwitch({
                            item,
                            key,
                            cKey: null,
                            value: e
                          })
                      "
                    />
                    <div
                      v-if="showSettingTag(key)"
                      :class="[
                        menuClassNameDone(key),
                        'bi-tmpl-detail__left__setting'
                      ]"
                    >
                      {{ settingText(key) }}
                    </div>
                  </div>
                </div>

                <!-- 子菜单 -->
                <div
                  v-if="item.renderChild"
                  class="bi-tmpl-detail__left__item__content__child"
                >
                  <div
                    class="bi-tmpl-detail__left__item__content__child__item"
                    v-for="(cItem, cKey) in item.value"
                    :key="cKey"
                    @click.stop
                  >
                    <span
                      @click.stop="onChangeMenu(key, cKey)"
                      :style="{
                        color:
                          state.activeMenu[1] === cKey
                            ? 'var(--xrk-color-primary)'
                            : '#4c4c4c',
                        cursor: 'pointer'
                      }"
                    >
                      {{ (cItem as any).title }}
                    </span>
                    <BaseSwitch
                      style="flex-shrink: 0; margin-left: 6px"
                      size="small"
                      :model-value="(cItem as any).show"
                      :activeText="item.show ? '展示' : '不展示'"
                      :disabled="!preValueDone(cKey) || isCheck"
                      @click.stop
                      @change="
                        e =>
                          onChangeSwitch({
                            item,
                            key,
                            cKey,
                            value: e
                          })
                      "
                    />
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </BaseScrollbar>
      </div>
      <div class="bi-tmpl-detail__right">
        <div
          style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"
        >
          <div class="bi-tmpl-detail__right__header">
            <div style="font-weight: 600; margin-left: 24px">模板编辑</div>
            <div class="bi-tmpl-detail__right__header-operate">
              <BaseInput
                class="bi-input"
                style="width: 248px"
                placeholder="请输入模板名称"
                v-model="state.templateName"
                :maxlength="20"
                :disabled="isCheck"
              />

              <BaseButton
                style="margin-left: 12px"
                type="default"
                @click="() => onCancel()"
              >
                返回
              </BaseButton>

              <div v-if="!isCheck" style="margin-left: 12px">
                <BaseButton
                  type="default"
                  @click="onPreview"
                  :disabled="!state.menuValue.get(ModelType['COVER']).value"
                >
                  预览
                </BaseButton>
                <BaseButton :click="onSave">保存</BaseButton>
              </div>
            </div>
          </div>
          <BaseScrollbar style="height: calc(100% - 66px)" always>
            <div class="bi-tmpl-detail__right__box" ref="rightBox">
              <BiTmplDetailForm>
                <template v-slot="{ disabled }">
                  <component :is="cmpName" :disabled="disabled" />
                </template>
              </BiTmplDetailForm>
            </div>
          </BaseScrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, nextTick } from 'vue';

import {
  BaseSelect,
  BaseSwitch,
  BaseInput,
  BaseButton,
  XrkMessage,
  createDialog,
  BaseScrollbar
} from 'xrk-components';
import BiTmplDetailForm from '@V/bi-tmpl/src/components/bi-tmpl-detail/bi-tmpl-detail-form.vue';

import * as BiTemplDetail from '../components/bi-tmpl-detail';

import { ModelType, SCENE_MAPPING } from '../constants';

import { useBiTmplDetailSteup } from '../store';
import { storeToRefs } from 'pinia';

import { useRouter } from 'vue-router';

import usePreview from '../hooks/use-preview';

import { checkValueDone, useRouteQuery } from '../hooks';

const DEFAULT_MENU_TYPE = '101'; //  默认激活菜单
const NO_VISIBLE = ['101', '102']; // 不显示【展示】，默认必展示
const NO_SETTING = ['8', '9']; // 不展示【设置】，没有可设置内容

const router = useRouter();

const store = useBiTmplDetailSteup();
const { state } = storeToRefs(store);

const { onPreview } = usePreview();
const { query, isCheck } = useRouteQuery();

const rightBox = ref(null);
const cmpName = computed(() => {
  return BiTemplDetail['BiTmplDetail_' + state.value.activeMenu[0]];
});
const settingText = key => {
  return menuClassNameDone(key) ? '已设置' : '未设置';
};

/**
 * @description: 检测上一个菜单是否设置完成
 * @param {*} curKey
 * @return {boolean} true已完成
 */
const preValueDone = curKey => {
  let _curKey = curKey;
  const arrMenu: any = Array.from(state.value.menuValue).reduce(
    (arr: any[], item) => {
      if (item[1]?.defaultChildKey) {
        if (_curKey === item[0]) _curKey = item[1].defaultChildKey;

        arr = [
          ...arr,
          ...Object.entries(state.value.menuValue.get(item[0]).value)
        ];
      } else {
        arr.push(item);
      }
      return arr;
    },
    []
  );

  const curArrMenuIndex = arrMenu.findIndex(item => item[0] === _curKey);
  // 从第一个之后开始校验
  if (curArrMenuIndex) {
    const [preKey, preMenu] = arrMenu[curArrMenuIndex - 1];
    // 这两个不需要设置，让它俩下一个以热力图开始校验，偷懒，直接写死16
    if (NO_SETTING.includes(preKey)) {
      const _index = arrMenu.findIndex(
        item => item[0] === NO_SETTING[state.value.menuValue.get('8') ? 0 : 1]
      );
      const [, _preMenu] = arrMenu[_index - 1];
      return Boolean(checkValueDone(_preMenu));
    }
    return Boolean(checkValueDone(preMenu));
  }
  return true;
};
// 激活菜单样式
const menuClassNameActive = menuType => {
  return +state.value.activeMenu[0] === +menuType
    ? 'bi-tmpl-detail__left__item__content--active'
    : '';
};

// 激活菜单按钮样式
const menuIconClassNameActive = menuType => {
  return +state.value.activeMenu[0] === +menuType
    ? 'bi-tmpl-detail__left__item__icon--active'
    : 'bi-tmpl-detail__left__item__icon--default';
};

// 设置完毕菜单样式
const menuClassNameDone = menuType => {
  const curMenu = state.value.menuValue.get(menuType);
  return checkValueDone(curMenu) === 1
    ? 'bi-tmpl-detail__left__setting--done'
    : '';
};
// 是否显示菜单【已设置】标签
const showSettingTag = key => {
  if (NO_SETTING.includes(key)) return false;
  return true;
};
// 是否显示菜单【展示】
const showVisible = key => {
  if (NO_VISIBLE.includes(key)) return false;
  return true;
};
// 切换菜单，上一个设置完毕才可切换下一个
const onChangeMenu = async (parentKey, childKey?) => {
  const curKey = childKey || parentKey;
  const menuLevel = childKey ? 1 : 0;
  const curParentMenu = state.value.menuValue.get(parentKey);
  if (!preValueDone(curKey)) {
    XrkMessage.error('请完成上一个模块设置');
    return Promise.reject('请完成上一个模块设置');
  }
  if (curParentMenu.defaultChildKey) {
    store.setActiveMenu(parentKey, 0);
    if (!childKey) {
      // 有子集的，但是没有传子集key，取默认子集
      store.setActiveMenu(curParentMenu.defaultChildKey, 1);
    } else {
      store.setActiveMenu(curKey, menuLevel);
    }
  } else {
    store.setActiveMenu(curKey, menuLevel);
  }

  // 切换菜单后，右侧置顶
  rightBox.value && rightBox.value.scrollTo(0, 0);

  nextTick(() => {
    const el = document.querySelector('.bi-tmpl-detail__right__box');
    el?.scrollIntoView({
      block: 'start',
      inline: 'start'
    });
  });
};

// 是否展示
const onChangeSwitch = async ({ item, key, cKey, value }) => {
  // 校验并选择菜单
  await onChangeMenu(key, cKey);

  //设置子项是否展示
  if (cKey) {
    store.setMenuShow(item, value, cKey);
    //子项勾选父级自动勾上，子项没了父级也取消
    const hasShowKey = Object.keys(item.value).some(
      key => item.value[key].show
    );
    store.setMenuShow(item, hasShowKey);
  } else {
    //设置父项是否展示
    store.setMenuShow(item, value);
    //判断是否有子项
    if (item.renderChild || typeof item.value === 'object') {
      //有子项的菜单 父级变更子项联动
      Object.keys(item.value).forEach(cKey => {
        store.setMenuShow(item, value, cKey);
      });
    }
  }
};
const onChangeScene = v => {
  state.value.sceneType = v;
  onChangeMenu(DEFAULT_MENU_TYPE);

  nextTick(() => {
    const el = document.querySelectorAll('.bi-tmpl-detail__left__item');
    el?.[0]?.scrollIntoView({
      block: 'start',
      inline: 'start',
      behavior: 'smooth'
    });
  });
};

const onCancel = ref<(skip?: boolean) => void>(() => {
  router.replace({
    name: 'bi-tmpl-list'
  });
});
const onSave = async () => {
  await store.saveTmpl();
  await XrkMessage.success('保存成功');
  onCancel.value(true);
};

const initData = async () => {
  await store.initTmpl(query.id, query?.sceneType);

  const getValueString = () => {
    const res = {
      __type: state.value.sceneType,
      __name: state.value.templateName
    };
    state.value.menuValue.forEach((value, key) => {
      res[key] = JSON.stringify(value);
    });
    return JSON.stringify(res);
  };
  const oldValue = getValueString();
  onCancel.value = (skip: boolean) => {
    if (skip || oldValue === getValueString()) {
      router.replace({
        name: 'bi-tmpl-list'
      });
      return;
    }
    createDialog({
      width: 480,
      center: true,
      title: '提示',
      content: 'BI模板还未保存，退出后已配置内容将不会保存，是否现在退出？',
      confirmBtnConfig: { content: '立即退出', type: 'primary', show: true },
      cancelBtnConfig: { content: '暂不退出', type: 'default', show: true },
      beforeConfirm: done => {
        router.replace({
          name: 'bi-tmpl-list'
        });
        done();
      }
    });
  };
};

initData();
onChangeMenu(DEFAULT_MENU_TYPE);
</script>

<style lang="scss">
// 右侧组件样式
@import '../styles/bi-tmpl-detail-cmpt.scss';
</style>

<style lang="scss">
// 表格样式
@import '../styles/custom-table.scss';
.custom-table-for-cmpt {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  overflow: hidden;
  position: relative;

  thead {
    tr {
      height: $headerHeight;
    }
  }
  tbody {
    tr {
      height: $bodyHeight;
    }
  }

  td[rowspan='0'],
  th[rowspan='0'] {
    display: none;
    & > div {
      border: none !important;
    }
  }

  th {
    color: #3e3e3e;
    height: $headerHeight;
    font-size: 24px;
    position: relative;
    & > div {
      @include _custom_table_value;
    }
  }

  tr {
    position: relative;
    break-inside: avoid;
    td {
      font-size: 24px;
      color: #3e3e3e;
      height: inherit;
      & > div {
        @include _custom_table_value;
        white-space: initial;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
@import '@/styles/theme.scss';

.block {
  padding: 0 !important;
  overflow-x: auto;
}
$left-width: 443px;

* {
  font-size: 14px;
}

@mixin bi-tmpl-detail_header {
  height: 64px;
  padding: 0 16px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bi-tmpl-detail {
  width: 100%;
  min-width: 1400px;
  margin: 0 auto;
  height: 100%;
  @include flex_jc_ai(flex-start, flex-start);
  &__left {
    height: 100%;
    flex-shrink: 0;

    &__header {
      width: $left-width;
      @include bi-tmpl-detail_header;
      border-right: 1px solid #e5e5e5;
    }
    &__box {
      height: calc(100% - 66px);
      width: $left-width;
      border-right: 1px solid #e5e5e5;
      padding: 0 16px 16px;
    }
    &__item {
      &:active {
        opacity: 0.9;
      }

      &__icon--active {
        width: 20px;
        height: 20px;
        color: var(--xrk-color-primary);
      }
      &__icon--default {
        width: 20px;
        height: 20px;
        color: #767676;
      }
      &__content {
        padding: 18px 16px;
        border: 1px solid #e8e8e8;
        border-radius: 2px;

        &__headline {
          @include flex_jc_ai;
        }
        &__child {
          padding-left: 30px;
          font-size: 14px;
          // padding-right: 65px;
          &__item {
            width: calc(100% - 50px - 16px);
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }
      }
      &__content--active {
        border-color: var(--xrk-color-primary);
        background: #fffaf6;
      }
    }
    &__item--second {
      display: block;
      border-bottom: 1px solid #dcdfe6;
      padding: 35px 0;
    }

    &__switch {
      @include flex_jc_ai;
    }
    &__setting {
      margin-left: 16px;
      padding: 2px 4px;
      background: #cbcbcb;
      border-radius: 4px;
      font-size: 14px;
      color: #fff;
    }
    &__setting--done {
      background: var(--xrk-color-primary);
    }
    &__text {
      flex: 1;
      display: flex;
      align-items: center;
      color: #1a1a1a;
      font-weight: 600;
      &__tip {
        position: relative;
        &::after {
          content: '提示：分享收集时显示该模块';
          position: absolute;
          top: -17px;
          left: 29px;
          font-size: 12px;
          color: var(--xrk-color-primary);
        }
      }
    }
  }
  &__right {
    height: 100%;
    width: 100%;
    flex-grow: 1;
    position: relative;
    &__header {
      width: 100%;
      @include bi-tmpl-detail_header;
      &-operate {
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
    }
    &__box {
      width: 100%;
      height: calc(100% - 66px);
      padding: 0 72px 24px;
    }
  }

  ::v-deep .is-always-shadow {
    box-shadow: none !important;
  }
}
</style>
